interface IPropertyRegionLocationAncestor {
    name: string;
}

interface IPropertyRegionLocationRegion {
    short_name_reverted: string;
    stats: {
        region_type_city?: IPropertyRegionLocationAncestor | null;
        region_type_town?: IPropertyRegionLocationAncestor | null;
        region_type_district?: IPropertyRegionLocationAncestor | null;
        region_type_housing_estate?: IPropertyRegionLocationAncestor | null;
    } | null;
}

export const getPropertyRegionLocation = (region: IPropertyRegionLocationRegion, address: string): string => {
    const stats = region.stats;
    const locationParts = [
        stats?.region_type_city?.name || stats?.region_type_town?.name,
        stats?.region_type_district?.name,
        stats?.region_type_housing_estate?.name
    ].filter((value): value is string => Boolean(value));

    if (locationParts.length > 0) {
        return locationParts.join(", ");
    }

    return region.short_name_reverted || address;
};
interface IPropertyRegionLocationAncestor {
    name: string;
}

interface IPropertyRegionLocationRegion {
    short_name_reverted: string;
    stats: {
        region_type_city?: IPropertyRegionLocationAncestor | null;
        region_type_town?: IPropertyRegionLocationAncestor | null;
        region_type_district?: IPropertyRegionLocationAncestor | null;
        region_type_housing_estate?: IPropertyRegionLocationAncestor | null;
    } | null;
}

export const getPropertyRegionLocation = (region: IPropertyRegionLocationRegion, address: string): string => {
    const stats = region.stats;
    const locationParts = [
        stats?.region_type_city?.name || stats?.region_type_town?.name,
        stats?.region_type_district?.name,
        stats?.region_type_housing_estate?.name
    ].filter((value): value is string => Boolean(value));

    if (locationParts.length > 0) {
        return locationParts.join(", ");
    }

    return region.short_name_reverted || address;
};
